module.exports = __webpack_public_path__ + "img/AX.e22c9be3.png";